<script lang="ts" setup>
  import { onMounted, ref } from 'vue'
  import { type AvailableLocals } from '@/plugins/i18n.ts'
  import { useAppLanguage } from '@/composables/useAppLanguage.ts'

  const emit = defineEmits(['language-changed'])

  const appLanguage = useAppLanguage()

  type AvailableLanguages = {
    code: AvailableLocals
    name: string
  }

  const availableLanguages: AvailableLanguages[] = [
    { code: 'en', name: 'english' },
    { code: 'ar', name: 'arabic' },
  ]

  const currentLanguageCode = ref<AvailableLocals>('en')

  const languageForm = useForm('put', 'users/profile/language', {
    language: currentLanguageCode.value,
  } as { language: AvailableLocals })

  const handleChange = (languageCode: AvailableLocals) => {
    currentLanguageCode.value = languageCode
    emit('language-changed', languageCode)
    appLanguage.updateLocale(languageCode)
    languageForm.language = languageCode
    languageForm.submit()
  }

  onMounted(() => {
    const savedLanguage = appLanguage.current.value
    if (savedLanguage && availableLanguages.some(lang => lang.code === savedLanguage)) {
      currentLanguageCode.value = savedLanguage as AvailableLocals
    }
  })
</script>

<template>
  <div class="language-selector">
    <div class="text-gray-100 text-body-2 mb-2">
      <i18n-t keypath="choose_language" />
    </div>
    <v-btn-toggle
      v-model="currentLanguageCode"
      border
      class="d-flex justify-space-between ga-2 w-100"
      mandatory
      rounded="0"
      style="height: 82px"
      @update:model-value="handleChange"
    >
      <v-btn
        v-for="language in availableLanguages"
        :key="language.code"
        class="rounded-sm flex-grow-1 border-sm border-grey-700 border-opacity-100 bg-login-bg"
        height="80"
        :value="language.code"
      >
        <div class="d-flex flex-column align-center ga-2">
          <i18n-t :keypath="language.name" />
        </div>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>
